import { Box } from "@mui/material";
import React from "react";

import { SidebarMenu } from "@/components/sidebar/menu/SidebarMenu";

import { SidebarCollapseButton } from "./SidebarCollapseButton";

interface SidebarDrawerContentProps {
  collapsed: boolean;
  canCollapse: boolean;
  actualDrawerWidth: number;
  onCollapse: (collapsed: boolean) => void;
  onMenuItemClick?: () => void;
}

export const SidebarDrawerContent: React.FC<SidebarDrawerContentProps> = ({
  collapsed,
  canCollapse,
  actualDrawerWidth,

  onCollapse,
  onMenuItemClick,
}) => {
  const sidebarBgColor = "#1e293b"; // Sfondo sidebar
  const dividerColor = "#334155"; // Colore divisore

  return (
    <Box
      sx={{
        textAlign: "left",
        height: "100%",
        bgcolor: sidebarBgColor,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: actualDrawerWidth,
        position: "relative",
      }}
    >
      <SidebarCollapseButton
        collapsed={collapsed}
        onCollapse={onCollapse}
        canCollapse={canCollapse}
      />

      {/* Logo Section */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 3,
          px: 2,
          borderBottom: `1px solid ${dividerColor}`,
        }}
      >
        <img
          src="/logo.svg"
          alt="Logo"
          style={{
            width: collapsed ? "40px" : "120px",
            height: "auto",
            transition: "width 0.3s ease",
          }}
        />
      </Box>

      {/* Main Menu */}
      <Box
        sx={{
          width: "100%",
          pt: 2,
        }}
      >
        <SidebarMenu
          collapsed={canCollapse && collapsed}
          onMenuItemClick={onMenuItemClick}
          menuType="main"
        />
      </Box>

      {/* Spacer */}
      <Box sx={{ flex: 1 }} />

      {/* Bottom Menu - Esci */}
      <Box
        sx={{
          width: "100%",
          pb: 2,
        }}
      >
        <SidebarMenu
          collapsed={canCollapse && collapsed}
          onMenuItemClick={onMenuItemClick}
          menuType="bottom"
        />
      </Box>
    </Box>
  );
};
